import React from 'react';
import { SiteInfo } from '@/globals';
import { getCategoriesByProducts } from '@/js/repository/CategoryRepository';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import Head from "next/head";

export async function getServerSideProps(context: any) {
  const { locale } = context;
  const siteUrl = `https://${context.req.headers.host}`;

  const categories = await getCategoriesByProducts(locale);

  return {
    props: { categories, siteUrl },
  }
}

const PrivacyPolicy = (props: any) => {
  const { locale } = useRouter();
  const { t } = useTranslation(); 

  const lastUpdated = new Date('2025-05-28').toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' });

  const getPrivacyPolicyContent = () => {
    switch (locale) {
      case 'ko':
        return (
          <>
            <h1 className="text-2xl font-bold">개인정보 처리방침</h1>

            <h2 className="text-xl font-bold mt-4">소개</h2>
            <p>{SiteInfo.siteName}에서는 귀하의 개인정보 보호와 보안 유지에 최선을 다하고 있습니다. 본 개인정보 처리방침은 당사 웹사이트 및 서비스를 이용할 때 귀하의 정보를 어떻게 수집, 사용, 저장, 보호하는지 설명합니다. <b>귀하의 개인정보 보호가 최우선</b>이며, GDPR, CCPA 및 기타 국제 개인정보 보호법 등 관련 법규를 준수하여 최고 수준의 데이터 보호를 유지하고자 합니다.</p>

            <p><b>최종 업데이트:</b> 본 개인정보 처리방침은 {lastUpdated}에 마지막으로 업데이트되었으며, 당사 정책 또는 법적 요구사항 변경에 따라 수시로 갱신될 수 있습니다.</p>

            <h2 className="text-xl font-bold mt-4">수집하는 정보</h2>
            <p>당사는 더 나은 서비스 제공과 플랫폼 경험 개선을 위해 다음과 같은 정보를 수집합니다:</p>

            <p><b>자동 수집 정보:</b> 귀하가 웹사이트를 방문할 때 IP 주소, 브라우저 종류 및 버전, 운영체제, 참조 웹사이트, 방문한 페이지, 체류 시간 등 기술적 정보를 쿠키 및 유사 기술을 통해 자동으로 수집합니다.</p>

            <p><b>사용자 상호작용 데이터:</b> 거래 링크 클릭, 본인이 본 상품, 검색어, 필터링 설정, 탐색 패턴 등 웹사이트 내에서의 행동 정보를 수집하여 추천 알고리즘 개선에 활용합니다.</p>

            <p><b>기기 정보:</b> 기기 종류, 화면 해상도, 브라우저 기능 등 사용자 경험 최적화를 위해 기기 관련 정보를 수집할 수 있습니다.</p>

            <p><b>선택적 개인정보:</b> 문의나 업데이트 구독 시 자발적으로 이메일 주소 등 연락처 정보를 제공할 수 있습니다.</p>

            <h2 className="text-xl font-bold mt-4">정보 사용 목적</h2>
            <p>수집된 정보는 다음과 같은 합법적인 비즈니스 목적에 사용됩니다:</p>

            <p><b>서비스 제공:</b> 웹사이트 운영 및 유지, 관련 거래 정보 제공, 거래 큐레이션 알고리즘 최적화 등 서비스 수행에 사용됩니다.</p>

            <p><b>사용자 경험 향상:</b> 개인 맞춤화, 알고리즘 정확도 개선, 사용자 행동 기반 웹사이트 기능 최적화에 활용됩니다.</p>

            <p><b>분석 및 개선:</b> 웹사이트 사용 분석, 사용자 선호도 이해, 서비스 및 거래 선정 방법 지속적 개선을 위해 사용합니다.</p>

            <p><b>제휴 프로그램 준수:</b> 제휴 수수료 적절한 분배를 위해 추천 추적 및 관리에 활용됩니다.</p>

            <p><b>커뮤니케이션:</b> 문의 응대, 고객 지원 제공, 수신 동의한 경우 서비스 관련 중요 공지 발송에 사용됩니다.</p>

            <h2 className="text-xl font-bold mt-4">정보 공유</h2>
            <p>귀하의 개인정보를 제3자에게 판매하지 않으며, 다음과 같은 제한된 상황에서만 정보를 공유합니다:</p>

            <p><b>제휴사:</b> 거래 링크 클릭 시 AliExpress 및 제휴사 웹사이트로 이동하며, 이들 사이트는 자체 개인정보처리방침에 따라 별도로 정보를 수집할 수 있습니다.</p>

            <p><b>서비스 제공자:</b> 당사 웹사이트 운영, 분석, 기타 서비스 제공을 지원하는 신뢰할 수 있는 업체와 익명화된 집계 정보를 공유할 수 있으며, 이들은 비밀 유지 의무를 지닙니다.</p>

            <p><b>법적 요구사항:</b> 법률, 법원 명령, 정부 규제에 따른 요구가 있을 때, 또는 당사 권리 보호, 귀하 및 타인의 안전을 위해 필요한 경우 정보를 공개할 수 있습니다.</p>

            <p><b>사업 이전:</b> 합병, 인수, 자산 매각 시 사업 거래의 일부로 사용자 정보가 이전될 수 있으며, 동일한 개인정보 보호 조치가 적용됩니다.</p>

            <h2 className="text-xl font-bold mt-4">쿠키 및 추적 기술</h2>
            <p>웹사이트 이용 경험 향상과 서비스 개선을 위해 쿠키 및 유사 추적 기술을 사용합니다:</p>

            <p><b>필수 쿠키:</b> 웹사이트 기본 기능 수행에 필요하며 비활성화할 수 없습니다. 페이지 탐색, 보안 영역 접근을 지원합니다.</p>

            <p><b>분석 쿠키:</b> 방문자 행동, 인기 페이지, 탐색 경로 등을 이해하기 위해 사용합니다.</p>

            <p><b>성능 쿠키:</b> 웹사이트 로딩 시간, 오류 발생 등 성능 개선을 위한 정보를 수집합니다.</p>

            <p><b>제휴 추적:</b> 제휴 링크를 통한 구매 시 적절한 수수료 분배를 위해 사용합니다.</p>

            <p>브라우저 설정을 통해 쿠키 설정을 관리할 수 있으나, 일부 쿠키 비활성화 시 웹사이트 기능에 제한이 있을 수 있습니다.</p>

            <h2 className="text-xl font-bold mt-4">데이터 보안</h2>
            <p><b>업계 표준 보안 조치</b>를 도입하여 무단 접근, 변경, 공개, 파괴로부터 귀하의 정보를 보호합니다:</p>

            <p><b>기술적 보호:</b> 보안 서버, 암호화 프로토콜, 정기 보안 업데이트를 통해 데이터 전송 및 저장을 보호합니다.</p>

            <p><b>접근 통제:</b> 개인정보 접근 권한은 업무상 필요한 승인된 인원으로 제한하며 비밀 유지 의무를 부과합니다.</p>

            <p><b>정기 모니터링:</b> 보안 취약점 모니터링 및 신속한 대응 조치를 실시합니다.</p>

            <p><b>데이터 최소화:</b> 목적 달성을 위해 필요한 정보만 수집하며, 목적 달성 후에는 정보를 보유하지 않습니다.</p>

            <h2 className="text-xl font-bold mt-4">데이터 보유 기간</h2>
            <p>서비스 제공 및 본 개인정보 처리방침 목적 달성을 위해 필요한 기간 동안만 정보를 보유합니다:</p>

            <p><b>사용 데이터:</b> 웹사이트 이용 및 상호작용 데이터는 주로 24개월까지 보유합니다.</p>

            <p><b>기술 데이터:</b> 로그 파일 및 기술 정보는 최대 12개월간 보관됩니다.</p>

            <p><b>커뮤니케이션 기록:</b> 문의 시 관련 기록은 최대 3년간 보관하여 지속 지원 및 문제 해결에 활용합니다.</p>

            <h2 className="text-xl font-bold mt-4">귀하의 권리 및 선택권</h2>
            <p>지역에 따라 귀하는 개인정보에 대해 다음과 같은 권리를 가질 수 있습니다:</p>

            <p><b>접근 권리:</b> 당사가 보유한 귀하 개인정보 및 처리 방식을 요청할 수 있습니다.</p>

            <p><b>정정 권리:</b> 부정확하거나 불완전한 개인정보의 정정을 요청할 수 있습니다.</p>

            <p><b>삭제 권리:</b> 법적 및 운영 제한 범위 내에서 개인정보 삭제를 요청할 수 있습니다.</p>

            <p><b>수집 거부 권리:</b> 마케팅 커뮤니케이션 및 필수적이지 않은 쿠키 사용에 대해 거부할 수 있습니다.</p>

            <p><b>데이터 이동권:</b> 해당되는 경우, 구조화되고 기계 판독 가능한 형식으로 개인정보 사본을 요청할 수 있습니다.</p>

            <p>권리 행사를 위해서는 아래 연락처로 문의해 주시기 바랍니다.</p>

            <h2 className="text-xl font-bold mt-4">국제 데이터 전송</h2>
            <p>당사 웹사이트는 전 세계 사용자를 대상으로 하며, 귀하의 정보가 거주 국가 외 국가로 전송 및 처리될 수 있습니다. 이러한 전송은 관련 데이터 보호법을 준수하며, 적절한 보호 조치를 시행하여 안전하게 처리됩니다.</p>

            <h2 className="text-xl font-bold mt-4">아동 개인정보 보호</h2>
            <p>본 서비스는 13세 미만 아동(또는 관할지역 디지털 동의 연령 미만)을 대상으로 하지 않습니다. 아동 개인정보를 고의로 수집하지 않으며, 만약 적절한 동의 없이 수집한 사실을 알게 될 경우 신속히 삭제 조치합니다.</p>

            <h2 className="text-xl font-bold mt-4">제3자 링크</h2>
            <p>웹사이트 내 AliExpress 및 기타 제휴 사이트 링크가 포함되어 있으나, <b>이들 외부 사이트의 개인정보 처리방침에 대해 당사는 책임지지 않습니다.</b> 방문 전 각 사이트의 개인정보처리방침을 확인하시길 권장합니다.</p>

            <h2 className="text-xl font-bold mt-4">개인정보 처리방침 변경</h2>
            <p>본 개인정보 처리방침은 당사 정책, 기술, 법적 요건 등 변경에 따라 수시로 업데이트됩니다. 중대한 변경 시 웹사이트에 최신 &quot;최종 업데이트&quot; 날짜와 함께 공지하며, <b>변경 후 서비스 이용 지속 시 업데이트된 방침에 동의한 것으로 간주됩니다.</b></p>

            <h2 className="text-xl font-bold mt-4">문의하기</h2>
            <p>본 개인정보 처리방침이나 데이터 처리 관행에 관한 문의, 요청 사항이 있을 경우 아래 연락처로 문의해 주십시오:</p>

            <p><b>이메일:</b> <a href="mailto:prosense@prosense.co.kr">prosense@prosense.co.kr</a><br />
            <b>응답 시간:</b> 개인정보 관련 문의는 최대 30일 이내에 답변 드리도록 노력합니다.</p>

            <p>유럽연합(EU) 사용자께서는 개인정보 권리 침해가 있다고 판단될 경우 관할 데이터 보호 당국에 불만을 제기할 권리가 있습니다.</p>
          </>
        );
      case 'ja':
        return (
          <>
            <h1 className="text-2xl font-bold">プライバシーポリシー</h1>

            <h2 className="text-xl font-bold mt-4">はじめに</h2>
            <p>{SiteInfo.siteName}では、お客様のプライバシー保護と個人情報の安全確保に全力を尽くしています。本プライバシーポリシーは、当サイトおよびサービスご利用時にお客様の情報をどのように収集、使用、保存、保護しているかを説明します。<b>お客様のプライバシーは最優先事項</b>であり、GDPR、CCPAおよびその他の国際的なプライバシー規制を含む関連法令に準拠し、最高水準のデータ保護を維持しています。</p>

            <p><b>最終更新日：</b>本プライバシーポリシーは{lastUpdated}に最終更新されており、運用方針や法的要件の変更に応じて随時更新されることがあります。</p>

            <h2 className="text-xl font-bold mt-4">収集する情報</h2>
            <p>より良いサービスの提供とプラットフォーム体験の向上のため、以下の種類の情報を収集しています：</p>

            <p><b>自動的に収集される情報：</b>ウェブサイト訪問時にIPアドレス、ブラウザの種類とバージョン、OS、参照元ウェブサイト、閲覧ページ、滞在時間などの技術的情報をクッキーや類似技術を通じて自動的に収集します。</p>

            <p><b>ユーザーの操作データ：</b>取引リンクのクリック、閲覧した商品、検索クエリ、フィルタ設定、ナビゲーションパターンなどのウェブサイト上の操作情報を収集し、レコメンデーションアルゴリズムの改善に利用します。</p>

            <p><b>デバイス情報：</b>デバイスの種類、画面解像度、ブラウザ機能など、異なるプラットフォームでのユーザー体験を最適化するための情報を収集する場合があります。</p>

            <p><b>任意の個人情報：</b>お問い合わせや更新情報の購読時に、メールアドレスなどの連絡先情報を任意で提供いただくことがあります。</p>

            <h2 className="text-xl font-bold mt-4">情報の利用目的</h2>
            <p>収集した情報は以下の正当な事業目的で使用されます：</p>

            <p><b>サービス提供：</b>ウェブサイトの運営・維持、関連取引の表示、取引キュレーションアルゴリズムの最適化を行うため。</p>

            <p><b>ユーザー体験の向上：</b>個別化、アルゴリズムの精度向上、ユーザー行動に基づく機能最適化のため。</p>

            <p><b>分析と改善：</b>ウェブサイトの利用状況分析、ユーザー嗜好の理解、サービスと取引選定方法の継続的改善のため。</p>

            <p><b>アフィリエイトプログラム遵守：</b>紹介の追跡およびパートナープログラム要件に基づく適切な報酬配分のため。</p>

            <p><b>コミュニケーション：</b>お問い合わせ対応、カスタマーサポート、受信同意のある重要なお知らせの送信のため。</p>

            <h2 className="text-xl font-bold mt-4">情報の共有</h2>
            <p>お客様の個人情報を第三者に販売することはありませんが、以下の限定的な場合に情報を共有することがあります：</p>

            <p><b>アフィリエイトパートナー：</b>取引リンクをクリックするとAliExpressやその他パートナーのサイトへリダイレクトされます。これらのパートナーは独自のプライバシーポリシーに従い、別途データを収集する場合があります。</p>

            <p><b>サービス提供者：</b>ウェブサイト運営、分析、その他サービスの支援を行う信頼できるサービス提供者と、個人を特定できない集計情報を共有します。彼らは秘密保持義務を負います。</p>

            <p><b>法的要請：</b>法律、裁判所命令、政府規制により開示が必要な場合、または権利保護や安全確保のために必要と判断される場合に情報を開示します。</p>

            <p><b>事業譲渡：</b>合併、買収、資産売却等の際に、同様のプライバシー保護を条件としてユーザー情報が譲渡される場合があります。</p>

            <h2 className="text-xl font-bold mt-4">クッキーおよび追跡技術</h2>
            <p>閲覧体験の向上とサービス改善のため、クッキーや類似技術を使用しています：</p>

            <p><b>必須クッキー：</b>ウェブサイトの基本機能を支えるために必要で、無効化できません。ページナビゲーションやセキュア領域アクセスを可能にします。</p>

            <p><b>分析クッキー：</b>訪問者のウェブサイト利用状況、人気ページ、ナビゲーションパスの把握に使用します。</p>

            <p><b>パフォーマンスクッキー：</b>読み込み時間やエラー情報など、ウェブサイトのパフォーマンス改善のために情報を収集します。</p>

            <p><b>アフィリエイト追跡：</b>リンク経由の購入に対する正しい報酬配分のための追跡に使用します。</p>

            <p>ブラウザの設定でクッキー管理が可能ですが、特定クッキーの無効化は機能制限をもたらす可能性があります。</p>

            <h2 className="text-xl font-bold mt-4">データセキュリティ</h2>
            <p><b>業界標準のセキュリティ対策</b>を実施し、不正アクセス、改ざん、開示、破壊から情報を保護します：</p>

            <p><b>技術的保護策：</b>安全なサーバー技術、暗号化プロトコル、定期的なセキュリティアップデートを用いてデータの送受信と保管を保護します。</p>

            <p><b>アクセス制御：</b>業務上必要な認可された担当者のみに個人情報へのアクセスを限定し、秘密保持義務を課しています。</p>

            <p><b>継続的モニタリング：</b>システムの脆弱性を常時監視し、必要に応じて迅速に対応します。</p>

            <p><b>データ最小化：</b>目的に必要な情報のみを収集し、その目的達成後は速やかに破棄します。</p>

            <h2 className="text-xl font-bold mt-4">データ保持期間</h2>
            <p>サービス提供と本ポリシーの目的達成に必要な期間のみ情報を保持します：</p>

            <p><b>利用データ：</b>ウェブサイトの利用・操作データは分析とサービス改善のため最大24ヶ月保有します。</p>

            <p><b>技術データ：</b>ログファイルや技術情報は最大12ヶ月間保管します。</p>

            <p><b>通信記録：</b>お問い合わせ内容は継続的サポートと問題解決のため最大3年間保持します。</p>

            <h2 className="text-xl font-bold mt-4">お客様の権利と選択</h2>
            <p>居住地により以下の権利を有する場合があります：</p>

            <p><b>アクセス権：</b>当社が保有する個人情報およびその処理内容を要求できます。</p>

            <p><b>訂正権：</b>不正確または不完全な情報の訂正を請求できます。</p>

            <p><b>削除権：</b>法的・運用上の制限内で個人情報の削除を求めることができます。</p>

            <p><b>収集拒否権：</b>マーケティングコミュニケーションや必須でないクッキーの使用を拒否できます。</p>

            <p><b>データポータビリティ：</b>該当する場合、構造化され機械可読な形式で個人データのコピーを請求できます。</p>

            <p>これらの権利を行使するには、下記の連絡先までご連絡ください。</p>

            <h2 className="text-xl font-bold mt-4">国際データ転送</h2>
            <p>当サイトはグローバルにサービスを提供しており、お客様の情報は居住国以外の国へ転送・処理される場合があります。関連するデータ保護法を遵守し、適切な安全対策を実施しています。</p>

            <h2 className="text-xl font-bold mt-4">子どものプライバシー</h2>
            <p>本サービスは13歳未満（または管轄地域のデジタル同意年齢未満）を対象としていません。適切な同意なしに子どもの個人情報を収集しないよう努め、発覚次第速やかに削除します。</p>

            <h2 className="text-xl font-bold mt-4">第三者リンク</h2>
            <p>当サイトにはAliExpressやその他のパートナーサイトへのリンクがありますが、<b>これら外部サイトのプライバシー慣行について当社は責任を負いません。</b>リンク先のプライバシーポリシーをご確認ください。</p>

            <h2 className="text-xl font-bold mt-4">プライバシーポリシーの変更</h2>
            <p>本プライバシーポリシーは運用方針、技術、法的要件の変更に応じて随時更新されます。重要な変更時は、ウェブサイトに「最終更新日」と共に告知し、<b>更新後もサービスをご利用いただくことで変更に同意したものとみなされます。</b></p>

            <h2 className="text-xl font-bold mt-4">お問い合わせ</h2>
            <p>本プライバシーポリシーやデータ取り扱いに関するご質問、ご要望は以下までご連絡ください：</p>

            <p><b>メールアドレス：</b> <a href="mailto:support@{SiteInfo.siteName}">support@{SiteInfo.siteName}</a><br />
            <b>対応期間：</b>プライバシー関連のお問い合わせには30日以内に回答できるよう努めます。</p>

            <p>欧州連合（EU）にお住まいの方は、プライバシー権が侵害されたと感じた場合、最寄りのデータ保護当局に苦情を申し立てる権利があります。</p>
          </>
        );
      case 'es-ES':
        return (
          <>
            <h1 className="text-2xl font-bold">Política de Privacidad</h1>

            <h2 className="text-xl font-bold mt-4">Introducción</h2>
            <p>En {SiteInfo.siteName}, estamos comprometidos con la protección de su privacidad y la seguridad de su información personal. Esta Política de Privacidad explica cómo recopilamos, usamos, almacenamos y protegemos su información cuando utiliza nuestro sitio web y servicios. <b>Su privacidad es nuestra prioridad</b>, y nos dedicamos a mantener los más altos estándares de protección de datos en cumplimiento con leyes de privacidad aplicables, incluyendo GDPR, CCPA y otras regulaciones internacionales.</p>

            <p><b>Última actualización:</b> Esta Política de Privacidad fue actualizada por última vez el {lastUpdated} y puede actualizarse periódicamente para reflejar cambios en nuestras prácticas o requerimientos legales.</p>

            <h2 className="text-xl font-bold mt-4">Información que recopilamos</h2>
            <p>Recopilamos información para brindarle un mejor servicio y mejorar su experiencia en nuestra plataforma. Los tipos de información que recopilamos incluyen:</p>

            <p><b>Información recopilada automáticamente:</b> Cuando visita nuestro sitio web, recopilamos automáticamente cierta información técnica, incluyendo su dirección IP, tipo y versión del navegador, sistema operativo, sitio web de referencia, páginas vistas, tiempo pasado en páginas y otras estadísticas de uso mediante cookies y tecnologías similares.</p>

            <p><b>Datos de interacción del usuario:</b> Recopilamos información sobre cómo interactúa con nuestro sitio web, incluyendo clics en enlaces de ofertas, productos que visualiza, consultas de búsqueda, preferencias de filtro y patrones de navegación para mejorar nuestro algoritmo de recomendación.</p>

            <p><b>Información del dispositivo:</b> Podemos recopilar información sobre su dispositivo, incluyendo tipo de dispositivo, resolución de pantalla y capacidades del navegador para optimizar su experiencia en diferentes plataformas.</p>

            <p><b>Información personal opcional:</b> Si decide contactarnos o suscribirse a nuestras actualizaciones, puede proporcionar voluntariamente información personal como su dirección de correo electrónico u otros datos de contacto.</p>

            <h2 className="text-xl font-bold mt-4">Cómo usamos su información</h2>
            <p>Utilizamos la información recopilada para los siguientes fines comerciales legítimos:</p>

            <p><b>Prestación del servicio:</b> Para operar y mantener nuestro sitio web, mostrar ofertas relevantes y asegurar el rendimiento óptimo de nuestro algoritmo de curación de ofertas.</p>

            <p><b>Mejora de la experiencia del usuario:</b> Para personalizar su experiencia, mejorar la precisión de nuestro algoritmo y optimizar la funcionalidad del sitio basada en patrones de comportamiento de los usuarios.</p>

            <p><b>Análisis y mejora:</b> Para analizar el uso del sitio web, entender las preferencias de los usuarios y mejorar continuamente nuestros servicios y metodología de selección de ofertas.</p>

            <p><b>Cumplimiento del programa de afiliados:</b> Para rastrear referidos y asegurar una correcta atribución de comisiones en conformidad con los requisitos del programa de socios.</p>

            <p><b>Comunicación:</b> Para responder a sus consultas, proporcionar soporte al cliente y enviar actualizaciones importantes sobre nuestros servicios cuando haya optado por recibir dichas comunicaciones.</p>

            <h2 className="text-xl font-bold mt-4">Compartir información</h2>
            <p>Respetamos su privacidad y <b>no vendemos su información personal</b> a terceros. Sin embargo, podemos compartir cierta información en las siguientes circunstancias limitadas:</p>

            <p><b>Socios afiliados:</b> Cuando hace clic en enlaces de ofertas, será redirigido a AliExpress u otros sitios asociados. Estos socios pueden recopilar sus propios datos según sus políticas de privacidad, independientes de las nuestras.</p>

            <p><b>Proveedores de servicios:</b> Podemos compartir información agregada y no identificable personalmente con proveedores de servicios confiables que nos ayudan a operar el sitio web, realizar análisis o proporcionar otros servicios, siempre que acepten mantener la confidencialidad.</p>

            <p><b>Requisitos legales:</b> Podemos divulgar información cuando sea requerido por ley, orden judicial o regulación gubernamental, o cuando creamos que la divulgación es necesaria para proteger nuestros derechos, su seguridad o la de otros.</p>

            <p><b>Transferencias comerciales:</b> En caso de fusión, adquisición o venta de activos, la información del usuario puede transferirse como parte de la transacción comercial, sujeto a las mismas protecciones de privacidad.</p>

            <h2 className="text-xl font-bold mt-4">Cookies y tecnologías de seguimiento</h2>
            <p>Usamos cookies y tecnologías de seguimiento similares para mejorar su experiencia de navegación y nuestros servicios:</p>

            <p><b>Cookies esenciales:</b> Estas cookies son necesarias para que el sitio web funcione correctamente y no pueden desactivarse. Permiten funciones básicas como la navegación entre páginas y acceso a áreas seguras.</p>

            <p><b>Cookies analíticas:</b> Utilizamos cookies analíticas para entender cómo interactúan los visitantes con nuestro sitio, qué páginas son más populares y cómo navegan por nuestro contenido.</p>

            <p><b>Cookies de rendimiento:</b> Estas cookies nos ayudan a mejorar el rendimiento del sitio recopilando información sobre cómo utiliza nuestro sitio, incluyendo tiempos de carga y errores encontrados.</p>

            <p><b>Seguimiento de afiliados:</b> Usamos cookies para rastrear referidos afiliados y asegurar una correcta atribución de comisiones cuando realiza compras a través de nuestros enlaces.</p>

            <p>Puede controlar la configuración de cookies mediante las preferencias de su navegador, aunque desactivar ciertas cookies puede afectar la funcionalidad del sitio web.</p>

            <h2 className="text-xl font-bold mt-4">Seguridad de datos</h2>
            <p>Implementamos <b>medidas de seguridad estándar en la industria</b> para proteger su información contra acceso no autorizado, alteración, divulgación o destrucción:</p>

            <p><b>Salvaguardas técnicas:</b> Usamos tecnologías de servidores seguros, protocolos de encriptación y actualizaciones regulares de seguridad para proteger la transmisión y almacenamiento de datos.</p>

            <p><b>Controles de acceso:</b> Limitamos el acceso a la información personal a personal autorizado que necesite realizar sus funciones y está obligado a mantener la confidencialidad.</p>

            <p><b>Monitoreo regular:</b> Supervisamos continuamente nuestros sistemas para detectar posibles vulnerabilidades de seguridad e implementamos medidas de remediación rápidas cuando es necesario.</p>

            <p><b>Minimización de datos:</b> Recopilamos solo la información necesaria para nuestros fines declarados y la conservamos solo el tiempo necesario para cumplir con esos fines.</p>

            <h2 className="text-xl font-bold mt-4">Retención de datos</h2>
            <p>Mantenemos su información solo el tiempo necesario para proporcionar nuestros servicios y cumplir con los propósitos descritos en esta Política de Privacidad:</p>

            <p><b>Datos de uso:</b> Los datos de uso e interacción con el sitio web generalmente se retienen hasta por 24 meses para fines de análisis y mejora del servicio.</p>

            <p><b>Datos técnicos:</b> Los archivos de registro y la información técnica pueden conservarse hasta por 12 meses para fines de seguridad y resolución de problemas.</p>

            <p><b>Registros de comunicación:</b> Si nos contacta, podemos conservar los registros de comunicación hasta por 3 años para brindar soporte continuo y resolver cualquier problema.</p>

            <h2 className="text-xl font-bold mt-4">Sus derechos y opciones</h2>
            <p>Dependiendo de su ubicación, puede tener ciertos derechos con respecto a su información personal:</p>

            <p><b>Derechos de acceso:</b> Puede solicitar información sobre qué datos personales tenemos sobre usted y cómo se procesan.</p>

            <p><b>Derechos de corrección:</b> Puede solicitar la corrección de información personal inexacta o incompleta.</p>

            <p><b>Derechos de eliminación:</b> Puede solicitar la eliminación de su información personal, sujeto a ciertas limitaciones legales y operativas.</p>

            <p><b>Derechos de exclusión:</b> Puede optar por no participar en ciertas actividades de recopilación y procesamiento de datos, incluidas las comunicaciones de marketing y cookies no esenciales.</p>

            <p><b>Portabilidad de datos:</b> Cuando corresponda, puede solicitar una copia de sus datos personales en un formato estructurado y legible por máquina.</p>

            <p>Para ejercer estos derechos, comuníquese con nosotros utilizando la información proporcionada en la sección de contacto a continuación.</p>

            <h2 className="text-xl font-bold mt-4">Transferencias internacionales de datos</h2>
            <p>Nuestro sitio web atiende a usuarios a nivel mundial, y su información puede transferirse y procesarse en países distintos al suyo. Nos aseguramos de que tales transferencias cumplan con las leyes de protección de datos aplicables y aplicamos salvaguardias adecuadas para proteger su información durante estas transferencias internacionales.</p>

            <h2 className="text-xl font-bold mt-4">Privacidad de los niños</h2>
            <p>Nuestros servicios no están destinados a niños menores de 13 años (o la edad aplicable de consentimiento digital en su jurisdicción). No recopilamos intencionalmente información personal de niños. Si nos damos cuenta de que hemos recopilado información personal de un niño sin el consentimiento apropiado, tomaremos medidas para eliminar dicha información rápidamente.</p>

            <h2 className="text-xl font-bold mt-4">Enlaces a terceros</h2>
            <p>Nuestro sitio web contiene enlaces a sitios web de terceros, incluyendo AliExpress y otros sitios asociados. <b>No somos responsables de las prácticas de privacidad</b> de estos sitios externos. Le recomendamos revisar las políticas de privacidad de cualquier sitio web de terceros que visite a través de nuestros enlaces.</p>

            <h2 className="text-xl font-bold mt-4">Cambios en esta Política de Privacidad</h2>
            <p>Podemos actualizar esta Política de Privacidad periódicamente para reflejar cambios en nuestras prácticas, tecnología, requisitos legales u otros factores. Notificaremos a los usuarios sobre cambios significativos publicando la política actualizada en nuestro sitio web con una nueva fecha &quot;Última actualización&quot;. <b>El uso continuo de nuestros servicios</b> después de dichos cambios constituye la aceptación de la Política de Privacidad actualizada.</p>

            <h2 className="text-xl font-bold mt-4">Contáctenos</h2>
            <p>Si tiene preguntas, inquietudes o solicitudes relacionadas con esta Política de Privacidad o nuestras prácticas de datos, contáctenos en:</p>

            <p><b>Email:</b> <a href="mailto:support@{SiteInfo.siteName}">support@{SiteInfo.siteName}</a><br />
            <b>Tiempo de respuesta:</b> Nos esforzamos por responder a todas las consultas relacionadas con la privacidad dentro de los 30 días.</p>

            <p>Para usuarios en la Unión Europea, también tiene derecho a presentar una queja ante la autoridad local de protección de datos si cree que se han violado sus derechos de privacidad.</p>
          </>
        );
      case 'ru':
        return (
          <>
            <h1 className="text-2xl font-bold">Политика конфиденциальности</h1>

            <h2 className="text-xl font-bold mt-4">Введение</h2>
            <p>В {SiteInfo.siteName} мы обязуемся защищать вашу конфиденциальность и обеспечивать безопасность вашей личной информации. Настоящая Политика конфиденциальности объясняет, как мы собираем, используем, храним и защищаем вашу информацию при использовании вами нашего сайта и сервисов. <b>Ваша конфиденциальность — наш приоритет</b>, и мы стремимся поддерживать высочайшие стандарты защиты данных в соответствии с применимыми законами о конфиденциальности, включая GDPR, CCPA и другие международные нормативные акты.</p>

            <p><b>Последнее обновление:</b> Эта Политика конфиденциальности была обновлена {lastUpdated} и может периодически обновляться в связи с изменениями в нашей практике или законодательных требованиях.</p>

            <h2 className="text-xl font-bold mt-4">Информация, которую мы собираем</h2>
            <p>Мы собираем информацию для предоставления вам лучших услуг и улучшения вашего опыта на нашей платформе. Типы собираемой информации включают:</p>

            <p><b>Автоматически собираемая информация:</b> При посещении нашего сайта мы автоматически собираем техническую информацию, такую как IP-адрес, тип и версия браузера, операционная система, сайт-реферер, посещённые страницы, время, проведённое на страницах, и другие статистические данные о использовании с помощью файлов cookie и аналогичных технологий.</p>

            <p><b>Данные взаимодействия пользователя:</b> Мы собираем информацию о том, как вы взаимодействуете с нашим сайтом, включая клики по ссылкам с предложениями, просматриваемые товары, поисковые запросы, настройки фильтров и навигационные паттерны для улучшения нашего алгоритма рекомендаций.</p>

            <p><b>Информация об устройстве:</b> Мы можем собирать информацию об устройстве, такую как тип устройства, разрешение экрана и возможности браузера, чтобы оптимизировать ваш пользовательский опыт на различных платформах.</p>

            <p><b>Дополнительная личная информация:</b> Если вы решите связаться с нами или подписаться на обновления, вы можете добровольно предоставить личную информацию, такую как адрес электронной почты или другие контактные данные.</p>

            <h2 className="text-xl font-bold mt-4">Как мы используем вашу информацию</h2>
            <p>Мы используем собранную информацию для следующих законных бизнес-целей:</p>

            <p><b>Предоставление услуг:</b> Для работы и поддержки нашего сайта, отображения релевантных предложений и обеспечения оптимальной работы нашего алгоритма подбора предложений.</p>

            <p><b>Улучшение пользовательского опыта:</b> Для персонализации вашего опыта, повышения точности алгоритмов и оптимизации функционала сайта на основе поведения пользователей.</p>

            <p><b>Аналитика и улучшения:</b> Для анализа использования сайта, понимания предпочтений пользователей и постоянного улучшения наших услуг и методологии выбора предложений.</p>

            <p><b>Соблюдение партнёрских программ:</b> Для отслеживания рефералов и обеспечения корректного распределения комиссионных в соответствии с требованиями партнёрских программ.</p>

            <p><b>Коммуникация:</b> Для ответа на ваши запросы, предоставления поддержки клиентам и отправки важных обновлений о наших услугах при вашем согласии на получение таких сообщений.</p>

            <h2 className="text-xl font-bold mt-4">Передача информации</h2>
            <p>Мы уважаем вашу конфиденциальность и <b>не продаём вашу личную информацию</b> третьим лицам. Однако мы можем делиться некоторой информацией в следующих ограниченных случаях:</p>

            <p><b>Партнёры по партнёрской программе:</b> При переходе по ссылкам с предложениями вы будете перенаправлены на AliExpress или сайты других партнёров. Эти партнёры могут собирать свои собственные данные в соответствии со своими политиками конфиденциальности, которые независимы от нашей.</p>

            <p><b>Поставщики услуг:</b> Мы можем делиться агрегированной, не позволяющей идентифицировать личность, информацией с доверенными поставщиками услуг, которые помогают нам управлять сайтом, проводить аналитику или предоставлять другие услуги, при условии, что они обязуются соблюдать конфиденциальность.</p>

            <p><b>Требования закона:</b> Мы можем раскрывать информацию по требованию закона, судебного приказа или государственного регулятора, либо если считаем, что раскрытие необходимо для защиты наших прав, вашей безопасности или безопасности других лиц.</p>

            <p><b>Передача бизнеса:</b> В случае слияния, поглощения или продажи активов информация пользователей может передаваться в рамках сделки, при этом действуют те же меры защиты конфиденциальности.</p>

            <h2 className="text-xl font-bold mt-4">Файлы cookie и технологии отслеживания</h2>
            <p>Мы используем файлы cookie и аналогичные технологии отслеживания для улучшения вашего опыта просмотра и наших услуг:</p>

            <p><b>Необходимые cookie:</b> Эти cookie необходимы для правильной работы сайта и не могут быть отключены. Они обеспечивают базовые функции, такие как навигация по страницам и доступ к защищённым разделам.</p>

            <p><b>Аналитические cookie:</b> Мы используем аналитические cookie для понимания того, как посетители взаимодействуют с сайтом, какие страницы наиболее популярны и как пользователи перемещаются по контенту.</p>

            <p><b>Производительные cookie:</b> Эти cookie помогают нам улучшать производительность сайта, собирая информацию о том, как вы используете наш сайт, включая время загрузки и возникающие ошибки.</p>

            <p><b>Отслеживание партнёрских программ:</b> Мы используем cookie для отслеживания рефералов по партнёрским ссылкам и обеспечения корректного распределения комиссионных при покупке через наши ссылки.</p>

            <p>Вы можете управлять настройками cookie через предпочтения вашего браузера, однако отключение некоторых cookie может повлиять на функциональность сайта.</p>

            <h2 className="text-xl font-bold mt-4">Безопасность данных</h2>
            <p>Мы применяем <b>стандартные в отрасли меры безопасности</b> для защиты вашей информации от несанкционированного доступа, изменения, раскрытия или уничтожения:</p>

            <p><b>Технические меры:</b> Мы используем безопасные серверные технологии, протоколы шифрования и регулярные обновления безопасности для защиты передачи и хранения данных.</p>

            <p><b>Контроль доступа:</b> Мы ограничиваем доступ к личной информации уполномоченным сотрудникам, которым это необходимо для выполнения своих обязанностей, и которые обязаны соблюдать конфиденциальность.</p>

            <p><b>Регулярный мониторинг:</b> Мы постоянно следим за нашими системами на предмет возможных уязвимостей и оперативно принимаем меры по их устранению.</p>

            <p><b>Минимизация данных:</b> Мы собираем только информацию, необходимую для указанных целей, и храним её только столько, сколько необходимо.</p>

            <h2 className="text-xl font-bold mt-4">Срок хранения данных</h2>
            <p>Мы храним вашу информацию только столько, сколько необходимо для предоставления услуг и выполнения целей, описанных в настоящей Политике конфиденциальности:</p>

            <p><b>Данные об использовании:</b> Данные о взаимодействии с сайтом обычно хранятся до 24 месяцев для целей аналитики и улучшения сервиса.</p>

            <p><b>Технические данные:</b> Файлы журналов и техническая информация могут храниться до 12 месяцев для обеспечения безопасности и устранения неполадок.</p>

            <p><b>Записи коммуникаций:</b> Если вы связываетесь с нами, мы можем хранить записи общения до 3 лет для обеспечения поддержки и решения вопросов.</p>

            <h2 className="text-xl font-bold mt-4">Ваши права и выборы</h2>
            <p>В зависимости от вашего местоположения вы можете иметь определённые права относительно вашей личной информации:</p>

            <p><b>Право на доступ:</b> Вы можете запросить информацию о том, какие личные данные мы храним о вас и как они обрабатываются.</p>

            <p><b>Право на исправление:</b> Вы можете запросить исправление неточной или неполной личной информации.</p>

            <p><b>Право на удаление:</b> Вы можете запросить удаление своих личных данных, с учётом определённых юридических и операционных ограничений.</p>

            <p><b>Право отказаться:</b> Вы можете отказаться от определённых видов сбора и обработки данных, включая маркетинговые коммуникации и несущественные cookie.</p>

            <p><b>Право на перенос данных:</b> При применимых случаях вы можете запросить копию своих личных данных в структурированном, машиночитаемом формате.</p>

            <p>Чтобы воспользоваться этими правами, свяжитесь с нами, используя контактную информацию, приведённую ниже.</p>

            <h2 className="text-xl font-bold mt-4">Международные передачи данных</h2>
            <p>Наш сайт обслуживает пользователей по всему миру, и ваша информация может передаваться и обрабатываться в странах, отличных от вашей страны проживания. Мы обеспечиваем, чтобы такие передачи соответствовали применимым законам о защите данных и применяем соответствующие меры безопасности для защиты вашей информации во время международных передач.</p>

            <h2 className="text-xl font-bold mt-4">Конфиденциальность детей</h2>
            <p>Наши услуги не предназначены для детей младше 13 лет (или соответствующего возраста цифрового согласия в вашей юрисдикции). Мы не сознательно собираем личную информацию от детей. Если мы узнаем, что собрали такую информацию без надлежащего согласия, мы примем меры для её скорейшего удаления.</p>

            <h2 className="text-xl font-bold mt-4">Ссылки на сторонние сайты</h2>
            <p>Наш сайт содержит ссылки на сторонние сайты, включая AliExpress и другие сайты партнёров. <b>Мы не несем ответственности за практики конфиденциальности</b> этих внешних сайтов. Рекомендуем ознакомиться с политиками конфиденциальности любых сторонних сайтов, которые вы посещаете через наши ссылки.</p>

            <h2 className="text-xl font-bold mt-4">Изменения в этой Политике конфиденциальности</h2>
            <p>Мы можем периодически обновлять настоящую Политику конфиденциальности, чтобы отразить изменения в нашей практике, технологиях, законодательных требованиях или других факторах. Мы уведомим пользователей о значительных изменениях, разместив обновлённую политику на нашем сайте с новой датой &quot;Последнего обновления&quot;. <b>Продолжение использования наших услуг</b> после таких изменений означает принятие обновлённой Политики конфиденциальности.</p>

            <h2 className="text-xl font-bold mt-4">Свяжитесь с нами</h2>
            <p>Если у вас есть вопросы, сомнения или запросы, касающиеся этой Политики конфиденциальности или наших практик обработки данных, пожалуйста, свяжитесь с нами по адресу:</p>

            <p><b>Электронная почта:</b> <a href="mailto:support@{SiteInfo.siteName}">support@{SiteInfo.siteName}</a><br />
            <b>Время ответа:</b> Мы стараемся отвечать на все вопросы, связанные с конфиденциальностью, в течение 30 дней.</p>

            <p>Для пользователей из Европейского союза у вас также есть право подать жалобу в местный орган по защите данных, если вы считаете, что ваши права на конфиденциальность были нарушены.</p>
          </>
        );
      default:
        return (
          <>
            <h1 className="text-2xl font-bold">Privacy Policy</h1>

            <h2 className="text-xl font-bold mt-4">Introduction</h2>
            <p>At {SiteInfo.siteName}, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, store, and protect your information when you use our website and services. <b>Your privacy is our priority</b>, and we are dedicated to maintaining the highest standards of data protection in compliance with applicable privacy laws including GDPR, CCPA, and other international privacy regulations.</p>

            <p><b>Last Updated:</b> This Privacy Policy was last updated on {lastUpdated} and may be updated periodically to reflect changes in our practices or legal requirements.</p>

            <h2 className="text-xl font-bold mt-4">Information We Collect</h2>
            <p>We collect information to provide you with better service and improve your experience on our platform. The types of information we collect include:</p>

            <p><b>Automatically Collected Information:</b> When you visit our website, we automatically collect certain technical information including your IP address, browser type and version, operating system, referring website, pages viewed, time spent on pages, and other usage statistics through cookies and similar technologies.</p>

            <p><b>User Interaction Data:</b> We collect information about how you interact with our website, including clicks on deal links, products you view, search queries, filtering preferences, and navigation patterns to improve our recommendation algorithm.</p>

            <p><b>Device Information:</b> We may collect information about your device including device type, screen resolution, and browser capabilities to optimize your user experience across different platforms.</p>

            <p><b>Optional Personal Information:</b> If you choose to contact us or subscribe to our updates, you may provide personal information such as your email address or other contact details voluntarily.</p>

            <h2 className="text-xl font-bold mt-4">How We Use Your Information</h2>
            <p>We use the collected information for the following legitimate business purposes:</p>

            <p><b>Service Provision:</b> To operate and maintain our website, display relevant deals, and ensure optimal performance of our deal curation algorithm.</p>

            <p><b>User Experience Enhancement:</b> To personalize your experience, improve our algorithm accuracy, and optimize website functionality based on user behavior patterns.</p>

            <p><b>Analytics and Improvement:</b> To analyze website usage, understand user preferences, and continuously improve our services and deal selection methodology.</p>

            <p><b>Affiliate Program Compliance:</b> To track referrals and ensure proper attribution for affiliate commissions in compliance with partner program requirements.</p>

            <p><b>Communication:</b> To respond to your inquiries, provide customer support, and send important updates about our services when you have opted in to receive such communications.</p>

            <h2 className="text-xl font-bold mt-4">Information Sharing</h2>
            <p>We respect your privacy and <b>do not sell your personal information</b> to third parties. However, we may share certain information in the following limited circumstances:</p>

            <p><b>Affiliate Partners:</b> When you click on deal links, you will be redirected to AliExpress or other partner websites. These partners may collect their own data according to their privacy policies, which are independent of ours.</p>

            <p><b>Service Providers:</b> We may share aggregated, non-personally identifiable information with trusted service providers who assist us in operating our website, conducting analytics, or providing other services, provided they agree to maintain confidentiality.</p>

            <p><b>Legal Requirements:</b> We may disclose information when required by law, court order, or government regulation, or when we believe disclosure is necessary to protect our rights, your safety, or the safety of others.</p>

            <p><b>Business Transfers:</b> In the event of a merger, acquisition, or sale of assets, user information may be transferred as part of the business transaction, subject to the same privacy protections.</p>

            <h2 className="text-xl font-bold mt-4">Cookies and Tracking Technologies</h2>
            <p>We use cookies and similar tracking technologies to enhance your browsing experience and improve our services:</p>

            <p><b>Essential Cookies:</b> These cookies are necessary for the website to function properly and cannot be disabled. They enable basic functions like page navigation and access to secure areas.</p>

            <p><b>Analytics Cookies:</b> We use analytics cookies to understand how visitors interact with our website, which pages are most popular, and how users navigate through our content.</p>

            <p><b>Performance Cookies:</b> These cookies help us improve website performance by collecting information about how you use our site, including loading times and any errors encountered.</p>

            <p><b>Affiliate Tracking:</b> We use cookies to track affiliate referrals and ensure proper commission attribution when you make purchases through our links.</p>

            <p>You can control cookie settings through your browser preferences, though disabling certain cookies may affect website functionality.</p>

            <h2 className="text-xl font-bold mt-4">Data Security</h2>
            <p>We implement <b>industry-standard security measures</b> to protect your information against unauthorized access, alteration, disclosure, or destruction:</p>

            <p><b>Technical Safeguards:</b> We use secure server technologies, encryption protocols, and regular security updates to protect data transmission and storage.</p>

            <p><b>Access Controls:</b> We limit access to personal information to authorized personnel who need it to perform their job functions and are bound by confidentiality obligations.</p>

            <p><b>Regular Monitoring:</b> We continuously monitor our systems for potential security vulnerabilities and implement prompt remediation measures when necessary.</p>

            <p><b>Data Minimization:</b> We collect only the information necessary for our stated purposes and retain it only as long as needed to fulfill those purposes.</p>

            <h2 className="text-xl font-bold mt-4">Data Retention</h2>
            <p>We retain your information only as long as necessary to provide our services and fulfill the purposes outlined in this Privacy Policy:</p>

            <p><b>Usage Data:</b> Website usage and interaction data is typically retained for up to 24 months for analytics and service improvement purposes.</p>

            <p><b>Technical Data:</b> Log files and technical information may be retained for up to 12 months for security and troubleshooting purposes.</p>

            <p><b>Communication Records:</b> If you contact us, we may retain communication records for up to 3 years to provide ongoing support and resolve any issues.</p>

            <h2 className="text-xl font-bold mt-4">Your Rights and Choices</h2>
            <p>Depending on your location, you may have certain rights regarding your personal information:</p>

            <p><b>Access Rights:</b> You may request information about what personal data we hold about you and how it is processed.</p>

            <p><b>Correction Rights:</b> You may request correction of inaccurate or incomplete personal information.</p>

            <p><b>Deletion Rights:</b> You may request deletion of your personal information, subject to certain legal and operational limitations.</p>

            <p><b>Opt-Out Rights:</b> You may opt out of certain data collection and processing activities, including marketing communications and non-essential cookies.</p>

            <p><b>Data Portability:</b> Where applicable, you may request a copy of your personal data in a structured, machine-readable format.</p>

            <p>To exercise these rights, please contact us using the information provided in the Contact section below.</p>

            <h2 className="text-xl font-bold mt-4">International Data Transfers</h2>
            <p>Our website serves users globally, and your information may be transferred to and processed in countries other than your own. We ensure that such transfers comply with applicable data protection laws and implement appropriate safeguards to protect your information during international transfers.</p>

            <h2 className="text-xl font-bold mt-4">Children&apos;s Privacy</h2>
            <p>Our services are not intended for children under the age of 13 (or the applicable age of digital consent in your jurisdiction). We do not knowingly collect personal information from children. If we become aware that we have collected personal information from a child without appropriate consent, we will take steps to delete such information promptly.</p>

            <h2 className="text-xl font-bold mt-4">Third-Party Links</h2>
            <p>Our website contains links to third-party websites, including AliExpress and other partner sites. <b>We are not responsible for the privacy practices</b> of these external sites. We encourage you to review the privacy policies of any third-party websites you visit through our links.</p>

            <h2 className="text-xl font-bold mt-4">Changes to This Privacy Policy</h2>
            <p>We may update this Privacy Policy periodically to reflect changes in our practices, technology, legal requirements, or other factors. We will notify users of significant changes by posting the updated policy on our website with a new &quot;Last Updated&quot; date. <b>Continued use of our services</b> after such changes constitutes acceptance of the updated Privacy Policy.</p>

            <h2 className="text-xl font-bold mt-4">Contact Us</h2>
            <p>If you have questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at:</p>

            <p><b>Email:</b> <a href="mailto:support@{SiteInfo.siteName}">support@{SiteInfo.siteName}</a><br />
            <b>Response Time:</b> We strive to respond to all privacy-related inquiries within 30 days.</p>

            <p>For users in the European Union, you also have the right to lodge a complaint with your local data protection authority if you believe your privacy rights have been violated.</p>
          </>
        );
    }
  }

  return (
    <>
      <Head>
        <title>{`${t("privacyPolicy")} | ${ SiteInfo.siteName }`}</title>
        <meta name="description" content={`${t("siteDescription")}`} />
        <link rel="canonical" href={`${props.siteUrl}/privacyPolicy`} />
        <meta name="robots" content="index, follow" />
      </Head>
      {getPrivacyPolicyContent()}
    </>
  );
};

export default PrivacyPolicy;